import {ArrowRepeat, PencilSquare, PlusCircle, Trash, CheckCircle} from "react-bootstrap-icons";

export const EventIcon: React.FC<{ type: string }> = ({ type }) => {
  if (type.startsWith('add')) {
      return <PlusCircle/>;
  } else if (type.startsWith('publish')) {
    return <CheckCircle />;
  } else if (type.startsWith('edit')) {
    return <PencilSquare />;
  } else if (type.startsWith('remove')) {
    return <Trash />;
  } else if (type === 'change' || type === 'duplicate') {
    return <ArrowRepeat />;
  } else {
    return null;
  }
};